import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AIJobs() {
  const [jobs, setJobs] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/ai/jobs/me").then(r=>setJobs(r.data)).catch(()=>{}); }, []);

  return (
    <div className="space-y-5">
      <h1 className="text-3xl font-black tracking-tighter text-white" style={{fontFamily:'Outfit'}}>My AI Jobs</h1>
      {jobs.length === 0 ? <div className="card p-8 text-center text-gray-400">No AI jobs yet. Try the AI Website Builder or AI App Builder.</div> : (
        <div className="grid md:grid-cols-2 gap-4">
          {jobs.map(j => (
            <div key={j.id} className="card p-5">
              <div className="flex justify-between">
                <div className="text-cyan-400 text-xs uppercase tracking-wider">{j.type}</div>
                <span className="text-xs text-gray-500">{new Date(j.created_at).toLocaleString()}</span>
              </div>
              <h3 className="text-white font-semibold mt-1">{j.type === "website" ? j.input.business_name : j.input.name}</h3>
              <p className="text-gray-400 text-sm mt-1 line-clamp-2">{j.output?.tagline || j.output?.summary || "Generated blueprint"}</p>
              <button onClick={()=>setOpen(j)} className="btn-ghost !py-1.5 !px-3 mt-3 text-xs">View</button>
            </div>
          ))}
        </div>
      )}

      {open && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center px-5 py-10" onClick={()=>setOpen(null)}>
          <div onClick={e=>e.stopPropagation()} className="card p-6 w-full max-w-2xl max-h-[80vh] overflow-auto">
            <h3 className="text-xl font-bold text-white mb-3">{open.type} blueprint</h3>
            <pre className="text-xs text-gray-300 bg-black/40 p-4 rounded-md overflow-auto whitespace-pre-wrap">{JSON.stringify(open.output, null, 2)}</pre>
            <div className="text-right mt-3"><button onClick={()=>setOpen(null)} className="btn-ghost">Close</button></div>
          </div>
        </div>
      )}
    </div>
  );
}
